
import Vue from 'vue';
import i18n from "@/lang";
import POLICY_BASELINE_REPHRASE from "@/constant/policy_baseline_rephrase";
import {mdiArrowLeft} from "@mdi/js";
import uiService from "@/services/uiService";
import msDataProvider from "@/services/msDataProvider";
import issueBaseline from "@/constant/issueBaseline";
import {addAction} from "@/services/firebase/writeData";

export default Vue.extend({
  name: "IssueModal",
  props: ['value', 'app'],
  data() {
    return {
      resolveIssueModalOptions: {
        title: this.$t("APP.DETAIL"),
        cancel: this.$t("APP.CLOSE"),
        width: 600
      },
      resolveIssueModal: false,
      val: this.value,
      i18n,
      stepResolve: [],
      rescanAlert: false,
      POLICY_BASELINE_REPHRASE,
      pathImg: "",
      quickFixTips: false,
      os: null,
      issueBaselineResolve: {},
      baselineFailedList: [],
      expandedItems: [],
      mdiArrowLeft,
      binding: {},
      tableItems: [],
      onlyShowIssue: true
    }
  },
  watch: {
    value(val) {
      this.val = val;
    },
    val(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    close() {
      this.val = false;
      this.quickFixTips = false;
    },
    back() {
      this.resolveIssueModalOptions = {
        title: this.$t("APP.DETAIL"),
        cancel: this.$t("APP.CLOSE"),
        width: 600
      }
      this.quickFixTips = false;
    },
    policyKeyLabel(key) {
      return key.replace(/_/g, " ").replace(/\./, " ");
    },
    ignoreBaselineKey(key) {
      if (
          key === 'network-connection-is-secured' ||
          key === 'os-version-is-windows-10-or-above' ||
          key === 'bluetooth-is-turned-off' ||
          key === 'camera-is-turned-off' ||
          key === 'user-password-is-set'
      ) {
        return true
      }
      return false
    },
    async scan() {
      uiService.executeCommand("try", {
        func() {
          msDataProvider.executeCommand("deviceScan");
        },
      });
    },
    deviceResolve(issue) {
      this.rescanAlert = true
      this.$nextTick(() => {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand(
                "deviceResolveBaselineRule",
                issue.rule.key
            );
          },
          self: this,
        });
      });
    },
    viewGuideline(issue) {
      this.issueBaselineResolve = {};
      if (!issue.rule.resolve_admin_privilege_required && !this.ignoreBaselineKey(issue.rule.key)) {
        this.pathImg = ""
        this.quickFixTips = true;
        this.issueBaselineResolve = issue
        if (this.issueBaselineResolve) {
          const issueList = issueBaseline;
          for (const issue of issueList) {
            if (issue.key === this.issueBaselineResolve.rule.key) {
              this.stepResolve = issue.content
            }
          }
        }
        switch (issue.rule.key) {
          case 'antivirus-protection-mode-is-turned-on':
            this.pathImg = require('../../../../assets/images/img/38d0f343.png')
            break
          case 'uac-is-turned-on':
            this.pathImg = require('../../../../assets/images/img/uac.png')
            break
          case 'hotspot-is-turned-off':
            this.pathImg = require('../../../../assets/images/img/hotspot.png')
            break
          case 'shared-folder-is-turned-off':
            this.pathImg = require('../../../../assets/images/img/sharing-folder.png')
            break
          case 'external-storage-is-not-used':
            this.pathImg = require('../../../../assets/images/img/storage.png')
            break
          case 'os-security-is-up-to-date':
            this.pathImg = require('../../../../assets/images/img/os-up-to-date.png')
            break
        }
      } else {
        this.solveIssue(issue.rule.key)
      }
    },
    solutionIssue(issue) {
      const issueList = issueBaseline;
      for (const item of issueList) {
        if (item.key === issue) {
          return true;
        }
      }
      return false;
    },
    async solveIssue(issue) {
      const issueList = issueBaseline;
      const index = issueList.findIndex((item) => item.key === issue);
      const authenToken = sessionStorage.getItem('authenToken') || ""
      let authorizedToken = ''
      if (authenToken) {
        authorizedToken = `?focusContent=true&authorized_token=${authenToken}`
      }
      if (index >= 0) {
        if (issueList[index].url && typeof issueList[index].url === 'string') {
          issueList[index].url = issueList[index].url.replace('?focusContent=true', authorizedToken)
          try {
            await msDataProvider.executeCommand("extOpenUrl", {
              url: issueList[index].url,
            });
          } catch (e) {
            console.log(e);
          }
        } else if (issueList[index].key === 'network-connection-is-secured' && this.os === 'windows') {
          this.deviceResolve(this.tableItems.find(item => item.key === issue));
          return;
        }
      }
      await addAction(`click_to_issue_${issue}`, null, null, "", issueList[index].url)
    },
    // expandBaselineInvalid(baselines): void {
    //   if (baselines && Array.isArray(baselines) && baselines.length) {
    //     for (const item of baselines) {
    //       if (
    //           item &&
    //           this.checkArray(item.rule_verify_results)) {
    //         const invalidBaseline = item.rule_verify_results.some(
    //             (res) => !res.result
    //         );
    //         if (invalidBaseline) {
    //           this.expandedItems.push(item);
    //         }
    //       }
    //     }
    //   }
    // },
    onFilterBaseline(data) {
      const issueBaselineList = issueBaseline;
      if (Array.isArray(data)) {
        this.tableItems = [];
        data.forEach(baselines => {
          if (Array.isArray(baselines.rule_verify_results)) {
            const ruleVerifyResults = baselines.rule_verify_results.map(r => {
              const baseline = issueBaselineList.find(i =>  i.key === r.key)
              if(baseline) {
                return {
                  ...r,
                  quickFix: baseline.quickFix
                }
              }
              return {
                quickFix: false,
                ...r
              }
            })
            this.tableItems.push(...ruleVerifyResults);
          }
        });
      }
    },
    checkArray(arr) {
      return !!(arr && Array.isArray(arr) && arr.length);
    },
    // onSwitchBaseline(item: any): void {
    //   if (this.checkArray(this.tableItems)) {
    //     const elements = [];
    //     for (const itemElement of this.tableItems) {
    //       if (itemElement.baseline_id === item.baseline_id) {
    //         itemElement.show = !itemElement.show;
    //       }
    //       elements.push(itemElement);
    //     }
    //
    //     this.tableItems = [...elements];
    //   }
    // },
    filterLabel(rule: any, description: boolean = false) {
      const lang = i18n.locale
      const baselines = [...POLICY_BASELINE_REPHRASE]
      for (const baseline of baselines) {
        if (rule && rule.key && baseline.key === rule.key) {
          if (description) {
            return baseline.description[lang]
          }
          if (rule.result) {
            return baseline.comply[lang]
          }
          return baseline.violate[lang]
        }
      }
      return rule?.rule?.name || ''
    },
    showPopupIssueBaseline() {
      if (!this.binding.deviceVerifyResult) {
        return;
      }
      const issueDeviceList = [];
      const issueList = issueBaseline;
      this.baselineFailedList = [];
      if (
          this.app &&
          this.app.authorized_app &&
          this.app.authorized_app.failed_device_baseline_ids &&
          this.app.authorized_app.failed_device_baseline_ids.length
      ) {
        for (const issueId of this.app.authorized_app
            .failed_device_baseline_ids) {
          for (const resultDevice of this.binding.deviceVerifyResult
              .baseline_verify_results) {
            if (issueId === resultDevice.baseline_id) {
              for (const issueDevice of resultDevice.rule_verify_results) {
                if (!issueDevice.result) {
                  issueDeviceList.push(issueDevice);
                }
              }
            }
          }
        }
      }
      if (issueDeviceList.length > 0) {
        for (const issue of issueDeviceList) {
          for (const item of issueList) {
            if (item.key === issue.key) {
              issue.rule.url = item.url;
              this.baselineFailedList.push(issue);
            }
          }
        }
      }

      if (this.baselineFailedList.length) {
        this.resolveIssueModalOptions = {
          title: this.$t("SDP_APP.BASELINE_ISSUE"),
          cancel: this.$t("APP.CLOSE"),
          width: 600
        }
      } else {
        this.resolveIssueModalOptions = {
          title: this.$t("APP.DETAIL"),
          cancel: this.$t("APP.CLOSE"),
          width: 600
        }
      }
    },
    clickableBaseline(issue) {
      const issueBaselineList = issueBaseline;
      const hasIntroductionResolve = issueBaselineList.find(i => i.key === issue.key)
      return !issue.result && (hasIntroductionResolve || (issue.rule && issue.rule.resolve_url))
    },
    resolvedIssue(issue) {
      return issue.result === true
    }
  },
  computed: {
    issueCount() {
      return this.tableItems.reduce((val, item) => {
        if (item && !item.result) {
          val++;
        }
        return val;
      }, 0)
    },
  },
  async created() {
    this.os = sessionStorage.getItem("os");
    await msDataProvider.bindDataMany(
        ["deviceIssues", "devicePolicy", "deviceVerifyResult", "deviceScanning"],
        this.binding,
        this,
        (key, data) => {
          if (key === "deviceVerifyResult" && data.baseline_verify_results) {

            this.onFilterBaseline(data.baseline_verify_results);
            this.showPopupIssueBaseline();
          }
          if (key === "deviceScanning" && this.rescanAlert && !data) {
            this.rescanAlert = false
          }
        },
        this
    );
    if (
        this.binding.deviceVerifyResult &&
        this.checkArray(this.binding.deviceVerifyResult.baseline_verify_results)
    ) {
      await this.onFilterBaseline(
          this.binding.deviceVerifyResult.baseline_verify_results
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
})
